<template>
  <div><policies product="GDPR"></policies></div>
</template>

<script>
import policies from "./policies.vue";
export default {
  components: { policies },
};
</script>
